
import AddItemWithExistingPicker, { InputType } from "../../pages/template/AddItemWithExistingPicker";
import { PlusIcon } from "../../types/PlusIcon";
import { getTemplateProblems } from "../../api/questionsApi";
import { ProblemAnswer } from "../../types/Rows";

export const ProblemsHeader = ({
  saveProblemsAnswers,
  problemAnswers,
  addProblemQuestions,
  addProblemTypeToDictionary,
  reportId,
}: {
  saveProblemsAnswers: any;
  problemAnswers: Map<string, ProblemAnswer>;
  addProblemQuestions: ({ reportId, categoryId }: { reportId: string; categoryId: string }) => void;
  addProblemTypeToDictionary: ({ reportId, value }: { reportId: string; value: string }) => void;
  reportId: string;
}) => {
  return (
    <div className="flex items-center bg-[var(--sc-bg)] px-4 py-3 text-[11px] font-semibold uppercase tracking-[0.06em] text-[var(--sc-text)] border-b-2 border-[var(--sc-amber)] gap-3">
      <div className="w-[14%] min-w-0">Kategoria</div>
      <div className="w-[20%] min-w-0">Opis</div>
      <div className="w-[10%] min-w-0">Status</div>
      <div className="w-[16%] min-w-0">Osoba identyfikująca</div>
      <div className="w-[14%] min-w-0">Data identyfikacji</div>
      <div className="w-[14%] min-w-0 flex items-center justify-between">
        Data rozwiązania
        <AddItemWithExistingPicker
          saveExisting={(value) => {
            saveProblemsAnswers([...problemAnswers.values()]).then(() =>
              addProblemQuestions({
                reportId: reportId,
                categoryId: value,
              })
            );
          }}
          inputType={InputType.PICKFROMEXISTING}
          saveNew={(value) => {
            saveProblemsAnswers([...problemAnswers.values()]).then(() =>
              addProblemTypeToDictionary({
                reportId: reportId,
                value: value,
              })
            );
          }}
          items={async () => {
            let items = await getTemplateProblems();
            return items.categories.map((x) => ({
              id: x.id.toString(),
              name: x.value,
            }));
          }}
          text="Wybierz kategorię"
        >
          <PlusIcon />
        </AddItemWithExistingPicker>
      </div>
    </div>
  );
};